import React from "react";
import { useCall } from "../context/CallContext";

const IncomingCallModal = () => {
  const { incomingCall, acceptCall, rejectCall } = useCall();

  if (!incomingCall) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.35)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
      }}
    >
      <div
        style={{
          width: "360px",
          background: "#fff",
          borderRadius: "16px",
          padding: "24px",
          textAlign: "center",
          boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
        }}
      >
        <h3 style={{ marginBottom: "10px" }}>Incoming Call</h3>
        <div style={{ fontWeight: "700", fontSize: "18px" }}>
          {incomingCall.callerName}
        </div>
        <div style={{ color: "#666", marginTop: "6px" }}>
          {incomingCall.callerDepartment}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "12px",
            marginTop: "24px",
          }}
        >
          <button
            onClick={acceptCall}
            style={{
              border: "none",
              background: "green",
              color: "#fff",
              padding: "10px 18px",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            Accept
          </button>

          <button
            onClick={rejectCall}
            style={{
              border: "none",
              background: "red",
              color: "#fff",
              padding: "10px 18px",
              borderRadius: "10px",
              cursor: "pointer",
            }}
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  );
};

export default IncomingCallModal;